import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeoService } from '../../seo/seo.service';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-straordinaria',
  imports: [CommonModule],
  templateUrl: './straordinaria.html',
  styleUrls: ['./straordinaria.scss'],
})
export class StraordinariaComponent implements OnInit {
  constructor(private router: Router, private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.updateTags({
      title: 'Pulizia straordinaria e post cantiere a Pescara | SAMI Pulizie',
      description:
        'Pulizia straordinaria e post cantiere a Pescara: rimozione polveri sottili, residui di cemento, vernici e calcare. Interventi rapidi e su misura. Sopralluogo gratuito.',
      keywords:
        'pulizia post cantiere Pescara, pulizia straordinaria Pescara, pulizia post ristrutturazione, sgrossature, rimozione cemento, SAMI Pulizie',
      canonicalUrl: '/straordinaria',

      ogTitle: 'Pulizia straordinaria e post cantiere a Pescara | SAMI Pulizie',
      ogDescription:
        'Interventi professionali post ristrutturazione: residui di cemento, vernici, calcare e polveri sottili. Sopralluogo gratuito.',
      ogImage: '/assets/logo.png',
      ogType: 'website',

      twitterCard: 'summary_large_image',
      twitterTitle: 'Pulizia straordinaria e post cantiere a Pescara | SAMI Pulizie',
      twitterDescription:
        'Rimozione polveri, residui edili e pulizia profonda post lavori. Preventivo e sopralluogo gratuiti.',
      twitterImage: '/assets/logo.png',

      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Pulizia straordinaria e post cantiere',
        description:
          'Pulizia post ristrutturazione: rimozione polveri sottili, cemento, vernici e calcare, con rifinitura finale.',
        provider: {
          '@type': 'CleaningService',
          name: 'SAMI Pulizie',
          url: 'https://samipulizie.it/',
          logo: 'https://samipulizie.it/assets/logo.png',
        },
        areaServed: { '@type': 'City', name: 'Pescara' },
        url: 'https://samipulizie.it/straordinaria',
      },
    });
  }

  navigateToPreventiviSito() {
    this.router.navigateByUrl('/preventivo');
  }
}
